import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-073fafc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page d-full-w d-flex-column d-flex-1f d-overflow" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "d-flex-1f" }
const _hoisted_4 = { class: "item-label" }
const _hoisted_5 = { class: "item-time" }
const _hoisted_6 = { class: "item-points" }

import { ref } from 'vue'
import { GetServiceTimeData } from '@/api/neighborHomeApi';

import runEvn from "@/modular/runEvn/RunEvn";
import router from '@/router';

export default /*#__PURE__*/_defineComponent({
  __name: 'serviceDuration',
  setup(__props) {

const runEvnData = runEvn();
const fileBaseUrl = runEvnData.fileBaseUrl;

const params = {
	pageSize: 10,
	pageNum: 1,
	total: 1,
	campaignType: 2,
};

const withdrawal = ref({
	popupShow: true,
	formData: {
		title: ''
	}
});

const rules = ref({
	title: [{ required: true, message: '请填写帖子主题' }],
	helptype: [{ required: true, message: '请选择求助类型' }],
	contactUser: [{ required: true, message: '请填联系人' }],
	phone: [{ required: true, message: '请填写联系电话' }],
});


function onSubmit() {
	console.log('提交');
}

async function loadData({ index, setData }) {
	params.pageNum = index;

	const res = await GetServiceTimeData(params);
	setData(res.rows, res.total);
}

function img(key: string) {
	return fileBaseUrl + key;
}


const pageData = ref({} as any);
function loadPageData() {
	// 这里需要接口请求
	pageData.value.img = "cCwuL3AvMjAyMTA4MjQvMTQ0Ny8yLDBlNDNjZGlkLnduMi5qcGc=";
	pageData.value.points = 2220;
}

return (_ctx: any,_cache: any) => {
  const _component_app_list = _resolveComponent("app-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_list, { onLoadData: loadData }, {
      default: _withCtx((slotProps) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "item-warp d-flex d-flex-h-center"
          }, [
            _createElementVNode("img", {
              src: img(item.headUrl),
              alt: "",
              class: "headUrl"
            }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.userName), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(new Date(item.createTimeStamp).format('yyyy-MM-dd HH:mm')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.points) + "小时 ", 1)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})